import { useTranslation } from 'react-i18next';
import { LifeBuoy } from 'lucide-react';
import { SUPPORT_BOT_URL } from '../ton/config';

/**
 * Opens the human support chat bot in Telegram. `block` renders the full-width
 * menu control (Profile sheet); `hint` renders an inline "problem? contact
 * support" line for error states and section footers.
 */
export function SupportLink({
  variant = 'block',
  className,
}: {
  variant?: 'block' | 'hint';
  className?: string;
}) {
  const { t } = useTranslation();
  if (variant === 'hint') {
    return (
      <a
        href={SUPPORT_BOT_URL}
        target="_blank"
        rel="noreferrer"
        className={`support-hint${className ? ` ${className}` : ''}`}
      >
        <LifeBuoy size={13} aria-hidden="true" /> {t('support.hint')}
      </a>
    );
  }
  const label = t('support.chat');
  return (
    <a
      href={SUPPORT_BOT_URL}
      target="_blank"
      rel="noreferrer"
      className={`partner-link partner-link--quiet${className ? ` ${className}` : ''}`}
      title={label}
      aria-label={label}
    >
      <LifeBuoy size={16} aria-hidden="true" />
      <span className="partner-link__label">{label}</span>
    </a>
  );
}
